import { useQueryClient } from '@tanstack/react-query';
import {
  API_ENDPOINT,
  useClientApiV1VouchersEnrollmentVerificationsConfirmUpdateMutation,
} from '../../../../../../resources/@types/courseSchema';
import { getVoucherEnrollmentVerificationsQueryKey } from '../queries/useVoucherEnrollmentVerificationsQuery';

export default function useVoucherEnrollmentVerificationConfirmUpdateMutation() {
  const queryClient = useQueryClient();
  return useClientApiV1VouchersEnrollmentVerificationsConfirmUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_VOUCHERS_ENROLLMENT_VERIFICATIONS_CONFIRM,
    options: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getVoucherEnrollmentVerificationsQueryKey());
      },
    },
  });
}
